/** Display-only: shortens an exercise name so a list row stays on one line. */
const EQUIPMENT = /^(barbell|dumbbell|dumbell|cable|kettlebell|smith machine|smith|machine|ez bar|ez-bar|trap bar|hex bar|landmine|lever|sled|resistance band|band|suspension|trx|ring|rings|weighted|bodyweight|medicine ball|battle rope)\s+/i;
const FILLER = /\b(variation|variations|version|exercise|movement|style)\b/gi;
const ABBREVIATIONS = [
  [/\bromanian deadlift\b/gi, 'RDL'],
  [/\bsingle[- ]arm\b/gi, '1-Arm'],
  [/\bsingle[- ]leg\b/gi, '1-Leg'],
  [/\balternating\b/gi, 'Alt'],
  [/\bhorizontal\b/gi, 'Horiz'],
  [/\bovehead|overhead\b/gi, 'OH'],
  [/\bextensions?\b/gi, 'Ext'],
  [/\bbent[- ]over\b/gi, 'Bent-Over'],
];
const POSTURE = /\b(standing|seated|lying|kneeling|supine|prone)\s+/gi;

const tidy = (s) => s.replace(/\s+/g, ' ').trim();

export function shortExerciseName(name = '', max = 20) {
  let s = tidy(String(name));
  if (s.length <= max) return s;

  // The row already shows the kit as an icon, so the equipment word is redundant.
  for (let i = 0; i < 2; i += 1) s = tidy(s.replace(EQUIPMENT, ''));
  if (s.length <= max) return s;

  s = tidy(s.replace(FILLER, ''));
  if (s.length <= max) return s;

  for (const [re, to] of ABBREVIATIONS) {
    s = tidy(s.replace(re, to));
    if (s.length <= max) return s;
  }

  s = tidy(s.replace(POSTURE, ''));
  if (s.length <= max) return s;

  // Last resort: keep the movement itself (the final two words).
  const words = s.split(' ');
  return words.length > 2 ? words.slice(-2).join(' ') : s;
}
